var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',{style:({
            'background-image': `url(${_vm.headerBackgroundImage})`
        })},[_c('b-img',{staticClass:"profile-img mt-4",attrs:{"thumbnail":"","rounded":"circle","src":_vm.profileImg,"alt":"Indiana"}})],1),_c('b-container',[_c('h1',{staticClass:"display-1 mt-5 mb-0"},[_vm._v(" Indiana "),_c('span',{staticClass:"surname"},[_vm._v("Lown-Collins")])]),_c('h2',{staticClass:"text-muted pb-3 mb-3"},[_c('em',[_vm._v("Award-Winning Theatre Director")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }